<!-- HERO-6-->	
			<section id="hero-6" class="hero-section division">

				<!-- SLIDER -->
				<div class="slider">
			    	<ul class="slides">


				     	<!-- SLIDE #1 -->
				      	<li id="slide-1">

					        <!-- Background Image -->
				        	<img src="assets/images/slide-4.jpg" alt="slide-background">

							<!-- Image Caption -->
		       				<div class="caption d-flex align-items-center center-align">
		       					<div class="container">
		       						<div class="row">
		       							<div class="col-md-12">
		       								<div class="caption-txt white-color">

						       					<!-- Title -->
					        					<h5>Welcome to Movement Clinic</h5>
								         	 	<h2>Top Class Medical Center</h2>
									          	
									          	<!-- Text -->
												<p class="p-md">Reliable, Accessible & Affordable Healthcare You Deserve. 
												   Serving with Care, Treating with Excellence Every Patient Matters!
												</p>

												<!-- Button -->
												<a [routerLink]="['/about-us']" class="btn btn-blue tra-white-hover">More About Clinic</a>

											</div>
										</div>
									</div>  <!-- End row -->
								</div>  <!-- End container -->
					        </div>	<!-- End Image Caption -->

					    </li>	<!-- END SLIDE #1 -->


				      	<!-- SLIDE #2 -->
				      	<li id="slide-2">

				        	<!-- Background Image -->
				        	<img src="assets/images/slide-5.jpg" alt="slide-background">

							<!-- Image Caption -->
	        				<div class="caption d-flex align-items-center center-align">
	        					<div class="container">
		       						<div class="row">
		       							<div class="col-md-12">
		       								<div class="caption-txt white-color">

					        					<!-- Title -->
					        					<h5>Our clinic Provide</h5>
								         	 	<h2>Total Health Care Solutions</h2>
									          	
									          	<!-- Text -->
												<p class="p-md">Complete Medical Services Under One Roof Because Your Health Matters.
												   Serving Families with Full-Spectrum Healthcare You Can Rely On
												</p>

												<!-- Button -->
												<a [routerLink]="['/about-us']" class="btn btn-tra-white black-hover mr-10">Get More Info</a>
												<a href="all-services.html" class="btn btn-blue blue-hover">Our Core Services</a>

											</div>	
				         				</div>
									</div>  <!-- End row -->
								</div>  <!-- End container -->
					        </div>	<!-- End Image Caption -->

				     	</li>	<!-- END SLIDE #2 -->


				     	<!-- SLIDE #3 -->
				      	<li id="slide-3">

				      		<!-- Background Image -->
				        	<img src="assets/images/slide-6.jpg" alt="slide-background">

				        	<!-- Image Caption -->
		       			 	<div class="caption d-flex align-items-center center-align">
		       			 		<div class="container">
		       						<div class="row">
		       							<div class="col-md-12">
		       								<div class="caption-txt white-color">

						       			 		<!-- Title -->
					        					<h5>Our Medical Staff</h5>
								         	 	<h2>High-Class Professionals</h2>

				                               <!-- Text -->
												<p class="p-md">Staffed with High-Class Professionals Experts Committed to Your Health. 
												   Where Medical Expertise Meets a Human Touch You’re in the Best Hands
												</p>

												<!-- Button -->
												<a href="all-doctors.html" class="btn btn-blue blue-hover mr-10">View All Doctors</a>
												<a href="timetable.html" class="btn btn-tra-white black-hover">Doctors Timetable</a>

											</div>
					        			</div>
									</div>  <!-- End row -->
								</div>  <!-- End container -->
					        </div>	<!-- End Image Caption -->

				     	</li>	<!-- END SLIDE #3 -->

				    </ul>
			  	</div>	<!-- END SLIDER -->


			</section>	<!-- END HERO-6 -->

